import React, {Component} from 'react';
import { connect } from 'react-redux';
import HourButton from '../../../SHARED/components/hourbutton/hourbutton.component';
import { getHallConfiguration } from '../../../SHARED/actions/movietheaters.actions'
import { storeSelectedHour } from '../../../SHARED/actions/filters.actions';
import { removeScheduleTicketClick } from  '../../../SHARED/actions/general.actions';
import { isEmpty } from '../../../SHARED/helpers/general.helper';
import moment from 'moment';

class ModalSelectHours extends Component  {

    componentDidMount(){
        if (!isEmpty(this.props.schedule)){
            //this.props.storeSelectedHour({projectionFormat: this.props.schedule.projection_format, hour: this.props.schedule.hour});
            this.props.getHallConfiguration(this.props.schedule.eventId);
            this.props.removeScheduleTicketClick();
        }
    }

    handleInteractivity = (hour, projectionFormat, eventId, scheduleId) => {
        this.props.getHallConfiguration(eventId);
        const userId = localStorage.getItem("user_id")
        this.props.storeSelectedHour({projectionFormat, hour, eventId, scheduleId, userId});
    };
    
    getContent = () => {
        if(this.props.movieSchedule.length){
            return this.props.movieSchedule.map((item, i) => {
                const currentHour = moment();
                let filteredHours = item.schedule_broadcast_hours.filter(hour => {
                    const momentHour = moment(this.props.selectedDate + ' ' + hour.schedule_broadcast_hour, 'YYYY.MM.DD HH:mm');
                    return momentHour.isAfter(currentHour)
                });
                item.schedule_broadcast_hours = filteredHours
                if (item.cinema && item.schedule_broadcast_hours.length > 0) {
                    return <div key={i}>
                        <p className="grey-text pdd5">{item.schedule_dubbed_subtitled}</p>
                        <div className="hours-section">
                            <div className="row hours-wrapper">
                                {item.schedule_broadcast_hours.map((hour, j) => {
                                    return <div className="col-lg-3 pdd5" key={j}>
                                        <HourButton 
                                            projectionFormat = {item.schedule_projection_format}
                                            hour = {hour.schedule_broadcast_hour}
                                            selectedValue = {this.props.selectedValue || ""}
                                            handleInteractivity = {(() => this.handleInteractivity(hour.schedule_broadcast_hour, item.schedule_projection_format, hour.schedule_event_id, hour.schedule_id))}
                                        />
                                    </div>
                                })}
                            </div>

                        </div>
                    </div>
                }
                else {
                    return null;
                }
            });
        }
        else {
            return <p className="grey-text">Momentan filmul nu ruleaza in cinematografe</p> 
        }
    }

    render() {
        return (
            <div className="hours-section">
                {this.getContent()}
            </div>
        );
    }
}

 const mapStateToProps = state => ({
     selectedValue: state.filters.movieDetailsFilters.hour,
     selectedDate: state.filters.reservetionSelectedDate
});
export default  connect(mapStateToProps, {getHallConfiguration, storeSelectedHour, removeScheduleTicketClick})(ModalSelectHours);



// WEBPACK FOOTER //
// ./src/FO/components/modalselecthours/modalselecthours.component.js